import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenParsedInitData} from "../server/data/TombOfAkhenatenParsedInitData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {Elastic, TimelineLite, TweenLite} from "gsap";
import {TombOfAkhenatenGameMode} from "../gameMode/TombOfAkhenatenGameMode";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export interface iWildFireConfig {
    topReelId : number,
    bottomReelId :number,
    reelId : number
}
export class SymbolsFireOverlayView extends BaseView {
    private _layer: ScalableLayer;
    private _layerMask: PIXI.Graphics;
    private _mainContainer: PIXI.Container;
    private _gameData: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData;
    private _wildFireConfigArr : iWildFireConfig[] = [];
    private _fireTl : TimelineLite;
    private static getSymbolPosition(reelId: number, rowCount: number): number[] {
        let symPos: number[] = Helper.getSymbolPositions(reelId, 0),
            bufferY: number = 0;

        switch (rowCount) {
            case 4:
                bufferY = -25;
                break;

            case 5:
                bufferY = -40;
                break;
        }

        symPos[1] = symPos[1] + bufferY;

        return symPos;
    }

    public onStonePress(rowCount: number, isAbort: boolean = false): void {
        if(this._fireTl?.isActive()){
            this._fireTl.pause().kill();
        }
        this._fireTl = new TimelineLite();
        for (let i: number = 0; i < TombOfAkhenatenGameConfig.instance.REELS_NUM; i++) {
            let symPositions: number[] = SymbolsFireOverlayView.getSymbolPosition(i, rowCount),
                spineContainer: PIXI.Container = (this._mainContainer.children[i] as PIXI.Container),
                symNewPosY: number = 0;

            if (rowCount === 4) {
                symNewPosY = 49.5 * (TombOfAkhenatenGameConfig.instance.MAX_ROWS - (i % TombOfAkhenatenGameConfig.instance.MAX_ROWS));
            } else if (rowCount === 5) {
                symNewPosY = (29 * (TombOfAkhenatenGameConfig.instance.MAX_ROWS - (i % TombOfAkhenatenGameConfig.instance.MAX_ROWS))) + 1.75;
            }

            if (this._gameData.nextMode.indexOf(TombOfAkhenatenGameMode.RESPIN_FINAL) > -1) {
                return;
            }

            const tl: TimelineLite = new TimelineLite();
            tl.delay(TombOfAkhenatenGameConfig.instance.STONE_PRESS_START_DELAY);
            tl.add(TweenLite.fromTo(spineContainer.position, TombOfAkhenatenGameConfig.instance.STONE_PRESS_DURATION, {
                y: spineContainer.y
            }, {
                y: symPositions[1] + symNewPosY,
                ease: Elastic.easeOut.config(1, 0.5)
            }), 0);
            rowCount > 3 && (<PIXI.Container[]>spineContainer.children).forEach((fireContainer: PIXI.Container) => {
                const scaleVal = rowCount == 4 ? 0.75 : 0.6
                tl.add(TweenLite.to(fireContainer.scale, 0.5, {y: scaleVal}), 0);
            });

            this._fireTl.add(tl,0);
        }
        //isAbort && this._fireTl.progress(1);
    }

    private onStonePressAbort(){
        if(this._fireTl?.isActive()){
            this._fireTl.progress(1);
        }
    }

    protected initAnimations() {
        super.initAnimations && super.initAnimations();

        this._layerMask = this.createLayerMask();
        this._mainContainer = this.createFireContainers();
        this._mainContainer.name = "mainContainer";

        this._layer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.FIRE_OVERLAY.name);
        this._layer.mask = this._layerMask;
        this._layer.addChild(this._layerMask, this._mainContainer);
    }

    private createLayerMask(): PIXI.Graphics {
        let mask: PIXI.Graphics = new PIXI.Graphics();
        mask.beginFill(0xFFFF0B, 0.5);
        mask.drawRect(TombOfAkhenatenGameConfig.instance.REEL_AREA_POS_X, TombOfAkhenatenGameConfig.instance.REEL_AREA_POS_Y, TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH, TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT);
        mask.endFill();

        return mask;
    }

    private onServerDataParsed(data: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData): void {
        this._gameData = data;
        this._wildFireConfigArr.length = 0;
        if(data instanceof TombOfAkhenatenParsedGameData){
            data.evaluatedArea.forEach((reelArr , colId)=>{
                reelArr.forEach((symName, rowId)=>{
                    if(symName === "W"){
                        const reelId : number = colId * 5 + rowId;
                        this._wildFireConfigArr.push({
                            topReelId : reelId - 1,
                            bottomReelId : reelId + 1,
                            reelId : reelId
                        });
                    }
                })
            });
            if(data.extraWildPosition[0] != -1){
                const reelId : number = data.extraWildPosition[0] * 5 + data.extraWildPosition[1];
                this._wildFireConfigArr.push({
                    topReelId : reelId - 1,
                    bottomReelId : reelId + 1,
                    reelId : reelId
                });
            }
        }else{
            data.reels.forEach((symArr, reelId)=>{
                if(symArr.indexOf("W") != -1){
                    this._wildFireConfigArr.push({
                        topReelId : reelId - 1,
                        bottomReelId : reelId + 1,
                        reelId : reelId
                    });
                }
            })
        }

    }

    private createFireContainers(): PIXI.Container {
        let wrapper: PIXI.Container = new PIXI.Container();

        for (let i: number = 0; i < TombOfAkhenatenGameConfig.instance.REELS_NUM; i++) {
            let spineContainer: PIXI.Container = this.createSpineContainer(i);
            wrapper.addChild(spineContainer);
        }

        return wrapper;
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_STONE_PRESS_ABORT, () => this.onStonePressAbort());
        EventHandler.addEventListener(this, TOAGameEvent.ON_STONE_PRESS, (event: GameEvent) => this.onStonePress(event.params[0], event.params[1]));
        // EventHandler.addEventListener(this, TOAGameEvent.ON_RESTORE, (event: GameEvent) => this.onRestore(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ADD_SYM_STATE_FIRE, (event: GameEvent) => this.playFire(event.params[0], event.params[1], event.params[2]));
        EventHandler.addEventListener(this, TOAGameEvent.REMOVE_SYM_STATE_FIRE, (event: GameEvent) => this.removeFire(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_NEW_GAME_ROUND, () => this.removeFire());
    }

    private createSpineContainer(reelId: number): PIXI.Container {
        let spineContainer: PIXI.Container = new PIXI.Container(),
            rowCount: number = TombOfAkhenatenGameConfig.instance.GAME_RESTORED ? this._gameData.activeRowsNextSpin : TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN,
            symPositions: number[] = SymbolsFireOverlayView.getSymbolPosition(reelId, rowCount);

        spineContainer.position.set(symPositions[0], symPositions[1]);
        spineContainer.name = "fire_" + reelId;
        spineContainer.visible = false;

        return spineContainer;
    }

    private removeFire(reelId?:number): void {
        if(reelId != undefined){
            let spineContainer: PIXI.Container = this._mainContainer.children[reelId] as PIXI.Container;
            this.removeItems(spineContainer);
            spineContainer.visible = false;
            spineContainer.removeChildren();
        }else{
            for (let i: number = 0; i < TombOfAkhenatenGameConfig.instance.REELS_NUM; i++) {
                let spineContainer: PIXI.Container = this._mainContainer.children[i] as PIXI.Container;
                this.removeItems(spineContainer);
                spineContainer.visible = false;
                spineContainer.removeChildren();
            }
        }
    }

    private removeItems(spineContainer: PIXI.Container): void {
        for (let j: number = 0; j < spineContainer.children.length; j++) {
            let fireContainer: PIXI.Container = spineContainer.children[j] as PIXI.Container;
            (<TimelineSprite[]>fireContainer.children).forEach((spriteTl: TimelineSprite) => spriteTl.stopLoop());
        }
    }

    private createFireSprite(symbolState: string, name: string, rowCount: number): TimelineSprite {
        const spriteTl: TimelineSprite = new TimelineSprite(GameResources.getTextures(symbolState + "Fire"));
        spriteTl.alpha = 1;
        spriteTl.pivot.x = 17;
        spriteTl.anchor.set(0.5);
        spriteTl.blendMode = PIXI.BLEND_MODES.ADD;
        spriteTl.name = "fire_" + name;
        switch (name) {
            case "top":
                spriteTl.position.y = -TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT * 0.5;
                spriteTl.scale.set(0.75);
                spriteTl.rotation = -1.5708
                break;
            case "bottom":
                spriteTl.position.y = TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT * 0.5;
                spriteTl.scale.set(0.75);
                spriteTl.rotation = +1.5708
                break;
            case "left":
                spriteTl.position.x = -TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH * 0.5;
                spriteTl.scale.x = -1;
                break;
            case "right":
                spriteTl.position.x = TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH * 0.5;
                break;
        }
        return spriteTl;
    }

    private addFireSprite(symbolState: string, reelId: number, rowCount: number): PIXI.Container {
        const fireContainer: PIXI.Container = new PIXI.Container();
        let isWildSubordinate : boolean = false;
        fireContainer.name = symbolState + "Fire";
        const spriteTlLeft: TimelineSprite = this.createFireSprite(symbolState, "left", rowCount);
        const spriteTlRight: TimelineSprite = this.createFireSprite(symbolState, "right", rowCount);
        const spriteTlTop: TimelineSprite = this.createFireSprite(symbolState, "top", rowCount);
        const spriteTlBottom: TimelineSprite = this.createFireSprite(symbolState, "bottom", rowCount);

        if(this._wildFireConfigArr.length){
            for (let i = 0; i < this._wildFireConfigArr.length; i++) {
                const wildFireConfig : iWildFireConfig = this._wildFireConfigArr[i];
                if(wildFireConfig.reelId == reelId){
                    fireContainer.addChild(spriteTlLeft, spriteTlRight);
                    isWildSubordinate = true;
                    break;
                }else if(wildFireConfig.topReelId == reelId){
                    fireContainer.addChild(spriteTlLeft, spriteTlRight, spriteTlTop);
                    isWildSubordinate = true;
                    break;
                }else if(wildFireConfig.bottomReelId == reelId){
                    fireContainer.addChild(spriteTlLeft, spriteTlRight, spriteTlBottom);
                    isWildSubordinate = true;
                    break;
                }
            }
        }

        !isWildSubordinate &&  fireContainer.addChild(spriteTlLeft, spriteTlRight, spriteTlTop, spriteTlBottom);

        if (rowCount == 5) {
            fireContainer.scale.y = 0.6;
        } else if (rowCount == 4) {
            fireContainer.scale.y = 0.75;
        }
        return fireContainer;
    }

    private playFire(reelId: number, symbolState: string, isInitialWinFire: boolean = false): void {
        let rowCount: number = TombOfAkhenatenGameConfig.instance.GAME_RESTORED ? this._gameData.activeRowsNextSpin : TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN,
            spineContainer: PIXI.Container = (this._mainContainer.children[reelId] as PIXI.Container),
            greenSpine: PIXI.Container = this.addFireSprite(TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.semiDimmed!.keyword, reelId, rowCount),
            yellowSpine: PIXI.Container = this.addFireSprite(TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win!.keyword, reelId, rowCount);

        this.removeItems(spineContainer);
        spineContainer.removeChildren();
        spineContainer.addChild(greenSpine, yellowSpine);

        for (let i: number = 0; i < spineContainer.children.length; i++) {
            let fireContainer: PIXI.Container = spineContainer.children[i] as PIXI.Container; //TODO container
            fireContainer.alpha = 0;
            if (fireContainer.name.indexOf(symbolState) > -1) {
                fireContainer.alpha = 1;
                (<TimelineSprite[]>fireContainer.children).forEach((spriteTl: TimelineSprite) => spriteTl.playLoop());
                if (isInitialWinFire) {
                    TweenLite.to(fireContainer, 1, {alpha: 0});
                }
            }
        }
        spineContainer.visible = true;

        if (TombOfAkhenatenGameConfig.instance.GAME_RESTORED) {
            this.onRestore(reelId, rowCount);
        } else {
            const symPositions: number[] = SymbolsFireOverlayView.getSymbolPosition(reelId, rowCount);
            spineContainer.position.set(symPositions[0], symPositions[1]);
        }

    }

    private onRestore(reelId: number, rowCount: number): void {
        let spineContainer: PIXI.Container = (this._mainContainer.children[reelId] as PIXI.Container);
        if (spineContainer.children.length) {
            let symPositions: number[] = SymbolsFireOverlayView.getSymbolPosition(reelId, rowCount);
            if (rowCount === 4) {
                spineContainer.position.y = symPositions[1] + ((TombOfAkhenatenGameConfig.instance.MAX_ROWS - (reelId % 5)) * 50);
            } else {
                spineContainer.position.y = symPositions[1] + ((TombOfAkhenatenGameConfig.instance.MAX_ROWS - (reelId % 5)) * 79) + ((reelId % 5) < 2 ? 10 : 0);
            }
        }
    }
}